import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ element, roles, ...rest }) => {
  const { user, getToken } = useContext(AuthContext);
  const token = getToken();
  const { handleLogout } = useContext(AuthContext);

  function isTokenValid(token) {
    if (!token) return false;
  
    try {
      
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
  
      // Check if token is expired
      if (decoded.exp < currentTime) {
        return false; // Token is expired
      }
      return true; // Token is valid
    } catch (error) {
      console.error("Invalid token", error);
      return false;
    }
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: rest.location }} />;
  }

  if(token)
  {    
    const isValid = isTokenValid(token);
    if(!isValid){
      handleLogout();
      return <Navigate to="/login" replace state={{ from: rest.location }} />;
    }
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: rest.location }} />;
  }

  return <>{element}</>;
};

export default ProtectedRoute;
